import React, { Component } from 'react';
import './Protocol.css';
import Nav from './Nav.js';
import Footer from './Footer.js';
import AppleModal from './AppleModal.js';

export default class RoomService extends React.Component {


    render() {
      
      return (
      
        
        <div class="main-wrapper" >

        <Nav />



        <img src="./images/blurred_background.png" class="blurred-background1" />
        <img src="./images/big_background_blur.png" class="bottom-background-blur" />

        <div class="protocol-header">
          <div class="modal-window" id="modal">
            <div class="modal-text-container">
          <h2>App Store Compliant</h2>
          <p>Most app stores require their own in-app purchase systems used to purchase digital goods.</p>
          <p>RoomService easily integrates with in-app purchase systems using a pre-paid system, so you can accept payments and fulfill transactions on-chain.</p>
          </div>
          <a href="#" class="modal__close">&times;</a>
          <div class="background-overlay"></div>

          </div>

          <div class="title">
          <h1>R O O M S E R V I C E</h1>
          <h2>Easily integrate NFTs with<br></br> in-app purchase.</h2>
          </div>
<a href="https://hjxig3ehz8e.typeform.com/to/ppCttHif"> <div class="get-the-app">Join the waitlist</div> </a>
{/* <img src="./images/down-arrow.png" class="down-arrow" /> */}
        </div>
        {/* <AppleModal>
      <div class="modal-background"></div>
    </AppleModal> */}

        <div class="wrapper-protocol">

    <div class="cards blue">
      <div class="card-text-container">
     <h2>Use Cases</h2>
     <p>Build NFT marketplaces and storefronts with minting and secondary sales.</p>
     <img src="./images/abstract.png" class="abstract-image"/>
     </div>
    </div>

    <div class="cards blue">
    <div class="card-text-container">
      <img src="./images/iphone_mock.png" class="app_image" />
     <h2> See it live</h2>
     <a href="https://apps.apple.com/us/app/firstfloor-live-nft-drops/id1596874081" target="_blank"><div class="CTA-buttons"> <p>App Store</p><img src="./images/button-arrow.png" class="button-arrow" /></div></a>

     </div>
    </div>

    <div class="cards blue">
    <div class="card-text-container">
    <img src="./images/apple_logo.png" class="apple_logo" />
     <h2> App Store Compliant</h2>
     <a href="#modal">
      <div class="CTA-buttons">
        <p onClick={this.props.handleOpen}>How?</p>
         <img src="./images/button-arrow.png" class="button-arrow" />
         </div>
         </a>
     </div>
    </div>
        </div>
        <Footer />
        </div>

      );
    }
  }